import {
    AstmaCopdOpties,
    ComorbiditeitenBehandelingenOpties,
    ComorbiditeitenMedicatieOpties,
    DiabetesMellitusOpties,
    LeverziektenOpties,
    MaligniteitenOpties,
} from '@common/customControls/bariatrics';
import {
    ConsistentieOntlastingOpties,
    OperatieTypeWensOpties,
} from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/bariPreNurseSpecialistMedScreeningReportData';

export const sortedAstmaCopdOpties = [
    AstmaCopdOpties.geen,
    AstmaCopdOpties.aanwezig,
    AstmaCopdOpties.aanwezig_met_inhalatiecorticosteroiden,
];

export const sortedComorbiditeitenBehandelingenOpties = [
    ComorbiditeitenBehandelingenOpties.geen,
    ComorbiditeitenBehandelingenOpties.aanwezig,
    ComorbiditeitenBehandelingenOpties.aanwezig_met_behandeling,
];
export const sortedComorbiditeitenMedicatieOpties = [
    ComorbiditeitenMedicatieOpties.geen,
    ComorbiditeitenMedicatieOpties.aanwezig,
    ComorbiditeitenMedicatieOpties.aanwezig_met_medicatie,
];
export const sortedConsistentieOntlastingOpties = [
    ConsistentieOntlastingOpties.waterdun,
    ConsistentieOntlastingOpties.dun,
    ConsistentieOntlastingOpties.brijig,
    ConsistentieOntlastingOpties.vast,
    ConsistentieOntlastingOpties.obstipatie,
    ConsistentieOntlastingOpties.met_zichtbaar_bloed,
    ConsistentieOntlastingOpties.met_slijm,
    ConsistentieOntlastingOpties.overig,
];
export const sortedDiabetesMellitusOpties = [
    DiabetesMellitusOpties.type_1_ongecompliceerd,
    DiabetesMellitusOpties.type_1_eindorgaanschade,
    DiabetesMellitusOpties.type_2_ongecompliceerd,
    DiabetesMellitusOpties.type_2_eindorgaanschade,
];
export const sortedLeverZiekteOpties = [LeverziektenOpties.geen, LeverziektenOpties.mild, LeverziektenOpties.ernstig];
export const sortedMaligniteitenOpties = [
    MaligniteitenOpties.geen,
    MaligniteitenOpties.lokaal,
    MaligniteitenOpties.metastasen,
];
export const sortedOperatieTypeWensOpties = [
    OperatieTypeWensOpties.keuzehulp_nog_invullen,
    OperatieTypeWensOpties.gastric_bypass,
    OperatieTypeWensOpties.gastric_sleeve,
    OperatieTypeWensOpties.mini_gastric_bypass,
    OperatieTypeWensOpties.anders,
];

export const additionalExaminations = [
    {
        fieldKey: 'cardiologisch_onderzoek',
        label: 'Cardiologisch onderzoek',
        textAreaFieldKey: 'cardiologisch_onderzoek_toelichting',
    },
    {
        fieldKey: 'onderzoek_interne_geneeskunde',
        label: 'Onderzoek interne geneeskunde',
        textAreaFieldKey: 'onderzoek_interne_geneeskunde_toelichting',
    },
    {
        fieldKey: 'slaaponderzoek',
        label: 'Slaaponderzoek',
        textAreaFieldKey: 'slaaponderzoek_toelichting',
    },
    {
        fieldKey: 'longfunctieonderzoek',
        label: 'Longfunctieonderzoek',
        textAreaFieldKey: 'longfunctieonderzoek_toelichting',
    },
    {
        fieldKey: 'ander_onderzoek',
        label: 'Ander onderzoek',
        textAreaFieldKey: 'ander_onderzoek_toelichting',
    },
] as const;
